module.exports = __webpack_public_path__ + "img/s9-1.df0f6977.jpg";